import { render, staticRenderFns } from "./AttendanceBoard.vue?vue&type=template&id=6ebfc366&scoped=true"
import script from "./AttendanceBoard.vue?vue&type=script&lang=js"
export * from "./AttendanceBoard.vue?vue&type=script&lang=js"
import style0 from "./AttendanceBoard.vue?vue&type=style&index=0&id=6ebfc366&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebfc366",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ebfc366')) {
      api.createRecord('6ebfc366', component.options)
    } else {
      api.reload('6ebfc366', component.options)
    }
    module.hot.accept("./AttendanceBoard.vue?vue&type=template&id=6ebfc366&scoped=true", function () {
      api.rerender('6ebfc366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Menus/components/AttendanceBoard.vue"
export default component.exports